export default __webpack_public_path__ + "static/media/benifit-one-icon.434793a7.svg";